var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredBadgeWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49999 6.00005C1.49999 7.19354 1.97411 8.33814 2.81803 9.18207C3.66195 10.026 4.80656 10.5001 6.00005 10.5001C7.19354 10.5001 8.33814 10.026 9.18207 9.18207C10.026 8.33814 10.5001 7.19354 10.5001 6.00005C10.5001 4.80656 10.026 3.66195 9.18207 2.81803C8.33814 1.97411 7.19354 1.49999 6.00005 1.49999C4.80656 1.49999 3.66195 1.97411 2.81803 2.81803C1.97411 3.66195 1.49999 4.80656 1.49999 6.00005Z",
    stroke: "#C08C17",
    strokeWidth: 1.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19941 7.19844L6 6.26556V4",
    stroke: "#C08C17",
    strokeWidth: 0.799609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredBadgeWaiting);
export default __webpack_public_path__ + "static/media/ic-colored-badge-waiting.e3d1c30607909333a52fedc26c3e5ca6.svg";
export { ForwardRef as ReactComponent };